import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgInfoOutline24 = function SvgInfoOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.09 5.828a.909.909 0 1 1 1.819.002.909.909 0 0 1-1.818-.002zm1.39 11.344h2.147v.96h-5.28v-.96h2.173V9.12H9.327v-.96h3.153v9.013zM12 23.04C5.913 23.04.96 18.087.96 12 .96 5.913 5.913.96 12 .96 18.087.96 23.04 5.913 23.04 12c0 6.087-4.953 11.04-11.04 11.04zM12 0C5.384 0 0 5.383 0 12c0 6.616 5.384 12 12 12 6.617 0 12-5.384 12-12 0-6.617-5.383-12-12-12z",
    fill: "currentColor"
  })));
};

var InfoOutline24Svg = SvgInfoOutline24;

export { InfoOutline24Svg as default };
//# sourceMappingURL=InfoOutline24.svg.js.map
